import moment from 'moment';
import qs from 'qs';

import { api } from '../../../../api';
import { bookingJournal, restaurateurBooking } from '../../../../config/api';
import { formatSystemDateTime } from '../../../shared/lib';

export const getActiveInPeriodRequest = (
  restaurantId: number,
  from: moment.Moment,
  till: moment.Moment,
) => {
  const url = `${bookingJournal}/${restaurantId}/booking/filter`;

  const params = {
    from: formatSystemDateTime(from),
    to: formatSystemDateTime(till),
    scheduled: true,
    status: ['ACCEPTED', 'IN_PROGRESS', 'PRE_CHECK', 'ARRIVED', 'AWAIT_PREPAY'],
    'include-arrived': true,
  };

  return api
    .get(url, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    .then((r: GM.Booking.Response.Filter) => r);
};

export const getUnknownGuestArrivedRequest = (tableId: number) => {
  const url = `${bookingJournal}/booking/table/${tableId}/arrive`;
  return api.post(url).then((r: GM.Booking.Response.GuestArrived) => r);
};

export const getGuestArrivedRequest = (reserveId: number) => {
  const url = `${bookingJournal}/booking/${reserveId}/arrive`;
  return api.post(url).then((r: GM.Booking.Response.GuestArrived) => r);
};

export const getGuestLeftRequest = (reserveId: number) => {
  const url = `${bookingJournal}/booking/${reserveId}/release`;
  return api.post(url).then((r: GM.Booking.Response.GuestLeft) => r);
};

export const getCancelReserveRequest = (id: number) => {
  const url = `${restaurateurBooking}/${id}`;
  return api.delete(url).then((r: GM.Booking.Response.Cancel) => r);
};

export const getMergeReserveWithOrderRequest = (reserveId: number, orderId: number) => {
  const url = `${bookingJournal}/booking/${reserveId}/link-order`;
  const data = {
    id: orderId,
  };

  return api.post(url, data).then((r: GM.Booking.Response.Merge) => r);
};
